import { chatbotRevealAnimation } from '@components/Chatbot/loading/QuestionLoadedAnimation'
import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

const StyledQuestionContainer = styled.div`
  ${({
    theme: {
      spacing: { spacing12 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing12};
    ${chatbotRevealAnimation}
  `}
`

export const QuestionContainer: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  return <StyledQuestionContainer>{children}</StyledQuestionContainer>
}
